import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

import { DarkHeroBackdrop } from '../../components/backdrops/HeroBackdrops';
import SecondaryLink from '../../components/buttons/SecondaryLink';
import { StrapiApiArticle } from '../../lib/integrations/strapi/types';
import pageRoutes from '../../router/pageRoutes';

type FeaturedBlogPostWidgetProps = {
  article: StrapiApiArticle;
};
const FeaturedBlogPostWidget: React.FC<FeaturedBlogPostWidgetProps> = React.memo((props) => {
  const {
    article: { attributes },
  } = props;
  const articleUrl = `${pageRoutes.Blog}/${encodeURIComponent(attributes.page_url)}`;

  return (
    <div>
      <p className="font-bold text-purple mb-4">Featured Post</p>
      <DarkHeroBackdrop className="rounded-3xl min-h-80 flex flex-col justify-around px-10 py-14">
        <div className="flex flex-col-reverse lg:flex-row items-center gap-10">
          <span className="block">
            <Link href={articleUrl}>
              <h3 className="font-bold mb-4 leading-none">{attributes.title}</h3>
            </Link>
            <p className="text-lg mb-4">{attributes.seo_description}</p>
            <SecondaryLink mode="dark" href={`${pageRoutes.Blog}/${encodeURIComponent(attributes.page_url)}`}>
              See more
            </SecondaryLink>
          </span>
          <Link href={articleUrl}>
            <Image width={600} height={600} src={attributes.imageUrl} alt={attributes.imageDescription} className="rounded-xl" />
          </Link>
        </div>
      </DarkHeroBackdrop>
    </div>
  );
});
FeaturedBlogPostWidget.displayName = 'FeaturedBlogPostWidget';
export default FeaturedBlogPostWidget;
